import { useParams } from 'react-router-dom'
import React from 'react'
import Card from './Card/Card'

function Invoice () {
  const [data, setData] = React.useState({ user: null, equipment: { value: null }, equipment_type: null })
  const [equipment, setEquipment] = React.useState({ display_name: 'equipment' })
  const [pageStatus, setPageStatus] = React.useState(null)
  const params = useParams()

  React.useEffect(() => {
    let isSubscribed = true
    setPageStatus('Loading reservation...')
    window.fetch(`/api/invoice/${params.reservationId}`)
      .then((res) => {
        if (res.status >= 400) {
          setPageStatus('Error: Reservation Not Found')
          throw new Error('Server responds with error!')
        }
        return res.json()
      })
      .then(
        (data) => {
          if (isSubscribed) {
            setData(data.result)
            setPageStatus('Complete')
          }
        },
        // Stryker disable next-line all
        (error) => console.log(error)
      )
    return () => { isSubscribed = false }
  }, [params.reservationId])

  React.useEffect(() => {
    let isSubscribed = true
    if (data.equipment.value) {
      setPageStatus('Loading equipment...')
      window.fetch(`/api/equipment/${data.equipment.value}`)
        .then((res) => {
          if (res.status >= 400) {
            setPageStatus('Error: Equipment Not Found')
            throw new Error('Server responds with error!')
          }
          return res.json()
        })
        .then(
          (data) => {
            if (isSubscribed) {
              setEquipment(data.result)
              setPageStatus('Complete')
            }
          },
          // Stryker disable next-line all
          (error) => console.log(error)
        )
    }
    return () => { isSubscribed = false }
  }, [data.equipment.value])

  return (
    <div className='invoice' style={{ height: '100%', width: '100%', backgroundColor: 'lightblue' }}>
      <div className='invoice-spacer' style={{ width: '100%', height: '30px' }} />
      <Card
        additional_charges={data.additional_charges}
        amount={data.amount}
        date={data.date}
        duration={data.duration}
        end_time={data.end_time}
        equipment_type={equipment.equipment_type}
        heartland_response={data.heartland_response}
        heartland_error={data.heartland_error}
        jefferson_employee={data.are_you_jefferson_employee}
        number={data.number}
        pageStatus={pageStatus}
        reservationId={params.reservationId}
        service_type={equipment.display_name}
        start_time={data.start_time}
        sys_created_by={data.sys_created_by}
        unitOfFee={equipment.unit_of_fee}
        units={data.units}
        user={data.user}
      />
      <div className='invoice-spacer' style={{ width: '100%', height: '30px' }} />
    </div>
  )
}

export default Invoice
